<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/lock-g.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">{{ data.titleKey | translate }}</h2>
      <p class="parent-dialog__subtitle">{{ data.bodyKey | translate }}</p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.identity.stepUp.cancel' | translate"
    (click)="cancel()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<form [formGroup]="form" (ngSubmit)="confirm()">
  <mat-dialog-content class="parent-dialog__body">
    <div class="parent-dialog__form">
      <app-input-field
        formControlName="password"
        [label]="'app.auth.password' | translate"
        [type]="'password'"
      />
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="parent-dialog__actions parent-dialog-actions"
    align="end"
  >
    <app-parent-button type="button" variant="ghost" (clicked)="cancel()">
      {{ 'app.identity.stepUp.cancel' | translate }}
    </app-parent-button>
    <app-parent-button type="submit" variant="primary">
      {{ (data.confirmKey || 'app.identity.stepUp.confirm') | translate }}
    </app-parent-button>
  </mat-dialog-actions>
</form>
